import { Component, OnDestroy, OnInit, Output } from '@angular/core';
import { Observable, Subject, Subscription, combineLatest } from 'rxjs';
import { DeviceGroupParam } from '../../models/group';
import { UpdateInfoModel } from '../../my-features/updateInfo/update-info.model';
import { MessageService, SelectItem } from 'primeng/api';
import * as shareModel from '../../shareModel';
import { Store } from '@ngrx/store';
import * as fromStore from '../../store';
import { updateInfoType } from '../../shareModel';
import * as fromMyfeatures from '../../my-features';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { isODM } from '../../../environments/environment';
import { Confirm_button } from '../../../environments/environment';
import {TranslateService} from '@ngx-translate/core';
import { RegionService } from 'src/app/services/region.service';
import { first, map, takeUntil } from 'rxjs/operators';
import { User } from '../../models/user';

@Component({
  standalone: false,
  selector: 'app-edit-group',
  templateUrl: './edit-group.component.html',
  styleUrls: ['./edit-group.component.css']
})
export class EditGroupComponent implements OnInit, OnDestroy {
  addDeviceList$: Observable<any>;
  private componentDestroyed = new Subject();
  loading = true;
  display = false;
  displayConfirmDialog = false;
  deviceSelectItem: any[] = [];

  private updateGroupInfo: Subscription;
  private groupBySelectedId: Subscription;
  groupIsErrorFlag = {
    gName: false,
    timeZone: false,
    devices: false,
  };
  deviceGroupParam = {} as DeviceGroupParam;
  UpdateInfoParam = {} as UpdateInfoModel;
  timezoneOptions: SelectItem[] = shareModel.timeZoneOption;
  groupOriginalData: any;
  powerMaster = isODM;
  Confirm_button = Confirm_button;
  mspRegionFilter = null;

  constructor(private translateService: TranslateService, private store: Store<fromStore.State>,
    private messageService: MessageService, private ngxService: NgxUiLoaderService,
    private regionService: RegionService) {
      // combineLatest(this.store.select(fromStore.getCurrentUser), this.store.select(fromStore.getMspRegionFilter))
      // .pipe(takeUntil(this.componentDestroyed)).subscribe(([user, filter]) => {
      //   this.mspRegionFilter = null;
      //   if (user && !user.isLoading && user.isLoaded && user.isLogin && filter !== null && filter.filterLoaded) {
      //     if (filter.isMsp) {
      //       this.mspRegionFilter = filter.selectedId;
      //     }
      //   }
      // });
      this.store.select(fromStore.getMspRegionFilter).pipe(takeUntil(this.componentDestroyed)).subscribe(res => {
        this.mspRegionFilter = null;
        if (res !== null && res.filterLoaded) {
          if (res.isMsp) {
            this.mspRegionFilter = res.selectedId;
          }
        }
      });
     }

  ngOnInit() {
  }

  updateGroupSave() {
    let valid = true;
    if (typeof this.deviceGroupParam.gName !== 'undefined' && this.deviceGroupParam.gName !== '') {
      this.groupIsErrorFlag.gName = false;
    } else {
      this.groupIsErrorFlag.gName = true;
      valid = false;
    }
    if (this.deviceGroupParam.timeZone !== null) {
      this.groupIsErrorFlag.timeZone = false;
    } else {
      this.groupIsErrorFlag.timeZone = true;
      valid = false;
    }
    this.groupIsErrorFlag.devices = false;
    if (!valid) {
      return;
    }
    // 組device, sharedevice參數
    this.deviceGroupParam = {
      ...this.deviceGroupParam,
      devices: this.deviceSelectItem
        .filter(item => this.deviceGroupParam.devices_selected.includes(item.value) && !item.is_shared)
        .map(item => item.value),
    };
    // this.deviceGroupParam.shared_devices = this.deviceSelectItem
    // .filter(item => this.deviceGroupParam.devices_selected.includes(item.value) && item.is_shared).map(item => item.value);

    // this.store.dispatch(new fromMyfeatures.UpdateInfoAction(this.UpdateInfoParam));
    this.store.dispatch(new fromStore.UpdateDeviceGroup({ ...this.deviceGroupParam }));
    this.store.select(fromStore.getUpdateInfoState)
      .pipe(first(res => res.isLoaded && res.type === updateInfoType.EditDeviceGroup))
      .subscribe(res => {
        if (res.type === updateInfoType.EditDeviceGroup) {
          if (res.isLoading) {
            console.log('...Loading');
          } else {
            if (res.isLoaded) {
              if (res.isSaved) {
                this.messageService.add({ severity: 'success', summary: this.translateService.instant('Update Success')});
                this.refresh();
              } else {
                this.messageService.add({ severity: 'error', summary: this.translateService.instant('Update Fail') });
              }
              this.resetUpdateInfoState();
            }
          }
        }
      });
  }

  private resetUpdateInfoState(type: string = updateInfoType.FreeState): void {
    this.UpdateInfoParam = { ...this.UpdateInfoParam, type };
    this.store.dispatch(new fromMyfeatures.UpdateInfoSuccessAction({ ...this.UpdateInfoParam }));
  }

  editGroup(gId) {
    this.deviceGroupParam = {} as DeviceGroupParam;
    this.groupIsErrorFlag.gName = false;
    this.groupIsErrorFlag.timeZone = false;
    this.groupIsErrorFlag.devices = false;
    this.groupBySelectedId = this.store.select(fromStore.getDeviceGroupByGroupId, gId)
      .pipe(takeUntil(this.componentDestroyed)).subscribe(res => {
        this.groupOriginalData = res;
        this.deviceGroupParam = {
          ...this.deviceGroupParam,
          gId: res.data.gId,
          gName: res.data.name,
          timeZone: res.data.timeZone,
          devices: [],
          devices_selected: [],
        };
        // this.deviceGroupParam.shared_devices = [];
        this.filterDevice();
      });
    this.groupBySelectedId.unsubscribe();
    this.display = true;
  }

  filterDevice() {
    this.addDeviceList$ = this.store.select(fromStore.getEditDevicesListToGroup,
      { gId: this.deviceGroupParam.gId });
    this.deviceSelectItem = [];
    this.store.select(fromStore.getEditDevicesListToGroup, { gId: this.deviceGroupParam.gId })
    .pipe(takeUntil(this.componentDestroyed)).subscribe(res => {
      res.map(item => {
        if (typeof item !== 'undefined' && item !== null) {
          this.deviceSelectItem.push(item);
        }
      });
    });
    this.deviceGroupParam = {
      ...this.deviceGroupParam,
      devices_selected: fromStore.filterEmptyChildren(this.groupOriginalData.children).map(item => {
        return Number(item.data.dcode);
      }),
    };
  }

  showConfirmDialog() {
    this.displayConfirmDialog = true;
  }

  refresh() {
    this.ngxService.start();
    // this.store.dispatch(new fromStore.GetDevicesStatusAction());
    // this.store.dispatch(new fromStore.GetDeviceInfoAction());
    // this.store.dispatch(new fromStore.GetGroups());
    const param = {regionIds : this.mspRegionFilter};
    const UserParam = {regionIds: this.mspRegionFilter} as User;
    this.store.dispatch(new fromStore.GetDevicesStatusAction(UserParam));
    this.store.dispatch(new fromStore.GetDeviceInfoAction(param));
    this.store.dispatch(new fromStore.GetGroups(param));

    this.display = false;
    this.ngxService.stop();
  }

  ngOnDestroy() {
    this.componentDestroyed.next(undefined);
    this.componentDestroyed.complete();
  }

}
